import { useState } from "react";
import { faqItems, faqCategories } from "@/mocks/home";

export default function Faq() {
  const [category, setCategory] = useState("全部");
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);

  const list =
    category === "全部" ? faqItems : faqItems.filter((item) => item.category === category);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center">
          <span className="text-xs md:text-sm font-medium tracking-wide text-accent-700">
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
            关于完整版与资源的常见疑问
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 max-w-2xl mx-auto">
            下面整理了浏览时最容易产生的八个问题，点击分类可以筛选，点击标题可以展开查看答案。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {faqCategories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setCategory(cat)}
              aria-pressed={category === cat}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors cursor-pointer whitespace-nowrap ${
                category === cat
                  ? "bg-secondary-500 text-background-50 border-secondary-500"
                  : "bg-background-50 text-foreground-700 border-background-300 hover:border-secondary-400 hover:text-secondary-700"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="mt-8 space-y-3">
          {list.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(item.id)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center gap-3 text-left px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-xs font-medium shrink-0 hidden sm:inline-block">
                    {item.category}
                  </span>
                  <span className="flex-1 font-heading text-sm md:text-base font-medium text-foreground-950">
                    {item.q}
                  </span>
                  <span className="w-7 h-7 shrink-0 rounded-full bg-background-200 text-foreground-700 flex items-center justify-center">
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600 border-t border-background-200 pt-4">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}